import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "summary-container"
};
const _hoisted_2 = ["id", "innerHTML"];
const _hoisted_3 = ["id", "innerHTML"];
const _hoisted_4 = ["aria-label"];
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "rc-generating-summary" };
import { ref, computed, nextTick, onMounted, inject } from "vue";
import { vTooltip } from "@/common/directives/tip-directive";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SummaryContent',
    props: {
        response: {},
        excerptable: { type: Boolean },
        showExpandToggle: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const isExpanded = ref(false);
        const shouldShowToggle = ref(false);
        const contentRef = ref();
        const i18n = inject("i18n");
        // Computed label for toggle button
        const toggleLabel = computed(() => (isExpanded.value ? i18n.t("Show Less") : i18n.t("Show More")));
        // Check if content height exceeds 200px after render
        const checkContentHeight = async () => {
            if (!props.showExpandToggle || !contentRef.value)
                return;
            await nextTick();
            const naturalHeight = contentRef.value.scrollHeight;
            shouldShowToggle.value = naturalHeight > 200;
        };
        onMounted(() => {
            checkContentHeight();
        });
        return (_ctx, _cache) => {
            return (__props.response.summary?.content)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", {
                        ref_key: "contentRef",
                        ref: contentRef,
                        class: _normalizeClass(["summary-content", {
                                'summary-content--condensed': !isExpanded.value && shouldShowToggle.value,
                                'summary-content--expanded': isExpanded.value
                            }])
                    }, [
                        (__props.excerptable && __props.response.summary?.highlights)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                id: 'rc-excerpt-' + __props.response.id + '-area--2-highlights',
                                class: "rc-highlight-area rc-highlight-area-content rc-RTEContent",
                                style: { "display": "block", "width": "100%" },
                                innerHTML: __props.response.summary.highlights
                            }, null, 8, _hoisted_2))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", {
                            id: 'rc-excerpt-' + __props.response.id + '-area--2',
                            class: "rc-excerpt-area rc-RTEContent",
                            innerHTML: __props.response.summary.content
                        }, null, 8, _hoisted_3)
                    ], 2),
                    (shouldShowToggle.value)
                        ? _withDirectives((_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: _normalizeClass(isExpanded.value ? 'rc-showLess' : 'rc-showMore'),
                            "aria-label": toggleLabel.value,
                            onClick: _cache[0] || (_cache[0] = ($event) => (isExpanded.value = !isExpanded.value))
                        }, [
                            _createTextVNode(_toDisplayString(isExpanded.value ? "<<" : "..."), 1)
                        ], 10, _hoisted_4)), [
                            [_unref(vTooltip), toggleLabel.value]
                        ])
                        : _createCommentVNode("", true)
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("Conversation summary is being generated...")), 1)
                ]));
        };
    }
});
